import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { copilotLogListSchema } from '../schemas/copilot-log-list.schema';

/**
 * Get log information for a specified list of Users.
 * @param externalIds Array of User External IDs
 * @param startDate Start Date
 * @param endDate End Date
 * @returns An array of CoPilot Log Lists for each User
 */
export function postUsersLogs(
  this: unknown,
  externalIds: string[],
  startDate: Date,
  endDate: Date
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${accountsEnvironment.resolve(this).usersUrl}/logs`, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
            ? new AuthHeaders()
            : jwtAuthHeaders),
        },
        body: JSON.stringify({
          externalIds,
          startDate,
          endDate,
        }),
      })
    )
  ).pipe(selectData(z.array(copilotLogListSchema)));
}
